import {
  isInvestor,
  isInstitutional,
  isContextAllowed,
  isLoggedIn,
  getUserContext,
  getAuthManagerInstance,
} from './authentication-manager.js'
import { setItem, getItem, removeItem } from '../data/synch-storage.js'
import { showAlertBanner } from '../../components/AlertBanner/index.js'
import { STATUS_ERROR } from '../../components/AlertBanner/Constants.js'
import { getRelativeBasePath } from '../environments/path.js'

const LOCKED_CONTENT_LINK_CLASS = 'locked-content-link'
const LOCKED_DOCUMENT_LINK_CLASS = 'locked-document-link'
const LOCKED_ICON_CLASS = 'locked-content-icon-link'
const NO_LOCK_ICON = 'no-lock-icon'
const NO_PERMISSON_CLASS = 'no-permission-link'
const STORAGE_KEY = 'DOCUMENT_TO_OPEN'
const LOGIN_REDIRECT_URL = getRelativeBasePath() + '/login?redirect='
const DISABLE_REDIRECT_CLASS = 'js-disable-login-redirect'

function init() {
  if (!isInvestor() && !isInstitutional()) {
    // add secure body class
    if (isLoggedIn()) {
      const bodyTag = document.getElementsByTagName('body')[0]
      if (bodyTag) {
        bodyTag.classList.add('authenticated')
      }
    }

    const profileBehaviorSubject =
      getAuthManagerInstance().getProfileServiceBehaviorSubject()
    profileBehaviorSubject.subscribe((event) => {
      if (event) {
        const url = getItem(STORAGE_KEY)
        if (url) {
          removeItem(STORAGE_KEY)
          window.open(url)
        }
      }
    })

    document.querySelectorAll('.' + NO_PERMISSON_CLASS).forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault()
        showAlertBanner({
          status: STATUS_ERROR,
          title: 'Locked',
          text: 'You do not have the proper permissions to view this link.',
        })
      })
    })

    document
      .querySelectorAll(
        '.' + LOCKED_DOCUMENT_LINK_CLASS + ', a[href*="/secure/"]'
      )
      .forEach((element) => {
        element.addEventListener('click', (event) => {
          if (!isLoggedIn()) {
            setItem(STORAGE_KEY, event.currentTarget.dataset.pdfRedirectUrl)
          }
        })
      })

    updateSecureLinks()
  }
}

function updateLinkData() {
  document
    .querySelectorAll(
      '.' +
        LOCKED_CONTENT_LINK_CLASS +
        ',' +
        '.' +
        LOCKED_DOCUMENT_LINK_CLASS +
        ', a[href*="login?redirect="], a[href*="/api/reports"], a[href*="/sc/"], a[href*="/secure/"]'
    )
    .forEach((link) => {
      updateLink(link)
    })
}

function updateLink(link) {
  const linkContext = link.dataset.ctx
  const linkContextArray = linkContext ? linkContext.split(' ') : []
  const isAuthenticated = isLoggedIn()

  if (isAuthenticated && isContextAllowed(getUserContext(), linkContextArray)) {
    link.classList.remove(LOCKED_ICON_CLASS)
    link.classList.add(NO_LOCK_ICON)
  } else if (isAuthenticated) {
    link.classList.add(NO_PERMISSON_CLASS)
  } else {
    let url, currentUrl

    if (
      link.classList.contains(LOCKED_DOCUMENT_LINK_CLASS) ||
      link.href.indexOf('secure') > 0
    ) {
      // if there is a locked document, store a url with the document id.

      // make sure that we don't override what is already set
      if (!link.dataset.pdfRedirectUrl) {
        link.dataset.pdfRedirectUrl = link.href
      }

      if (link.href && !link.href.indexOf('/login?redirect') >= 0) {
        url = LOGIN_REDIRECT_URL + window.location.href
      }

      link.removeAttribute('target')
    } else {
      // if a data attribute tells you to redirect, go there instead.
      currentUrl = link.dataset.redirectAuthenticatedUrl || link.href

      if (link.classList.contains(DISABLE_REDIRECT_CLASS)) {
        url = currentUrl
      } else {
        if (link.href.indexOf('/login?redirect') < 0) {
          url = LOGIN_REDIRECT_URL + currentUrl
        } else {
          url = currentUrl
        }
      }
    }

    link.href = url
  }
}

function resetPageLockedLinkStyles() {
  document
    .querySelectorAll(
      '.' + LOCKED_CONTENT_LINK_CLASS + ',' + '.' + LOCKED_DOCUMENT_LINK_CLASS
    )
    .forEach((link) => {
      resetLockedLinkStyle(link)
    })
}

function resetLockedLinkStyle(link) {
  link.classList.add(LOCKED_ICON_CLASS)
  link.classList.remove(NO_PERMISSON_CLASS)
}

function updateSecureLinks() {
  if (!isInvestor()) {
    resetPageLockedLinkStyles()
    updateLinkData()
  }
}

export {
  init,
  LOCKED_CONTENT_LINK_CLASS,
  LOCKED_DOCUMENT_LINK_CLASS,
  LOCKED_ICON_CLASS,
  NO_LOCK_ICON,
  LOGIN_REDIRECT_URL,
  DISABLE_REDIRECT_CLASS,
  updateSecureLinks,
  updateLink,
  resetLockedLinkStyle,
}
